import { render, staticRenderFns } from "./RoadmapsList.vue?vue&type=template&id=0235360c&scoped=true"
import script from "./RoadmapsList.vue?vue&type=script&lang=js"
export * from "./RoadmapsList.vue?vue&type=script&lang=js"
import style0 from "./RoadmapsList.vue?vue&type=style&index=0&id=0235360c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0235360c",
  null
  
)

export default component.exports